import React, { useState, useEffect } from "react";
import { RELATIONSHIPS, RULES } from "../../ISRConstants";
import {
  RuleObjectStateType,
  RuleObjectType,
} from "../../Pages/DefineModel/model";
import {
  TConnector,
  TField,
  TIndexState,
  TProductCategory,
  TSubmodel,
  TUpsertISRProjectDataModelsInput,
} from "../../Pages/DefineModel/model";
import RulesCard from "./RulesCard";
import ManageRulesDialog from "../../Pages/DefineModel/Components/ManageRulesDialog";
import CreateRuleMenu from "../CreateRuleMenu";
import { SB3RuleContextProvider } from "./SB3RuleContext";
import { useISRContext } from "../../Hooks/useISRContext";

type RulesComponentProps = {
  id: string;
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  setUserProjectDataModels: React.Dispatch<
    React.SetStateAction<TUpsertISRProjectDataModelsInput>
  >;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo?: TIndexState;
  createISRProject:(isRuleUpdate: boolean)=>void;
  featureType: string
};

// type commandType = {
//   id: number;
//   label: string;
//   description: string;
//   hasOptions: boolean;
//   onClickHandler: Function;
//   child: [];
//   type: string;
//   choiceType: string;
// };

const RulesComponent = (
  props: React.PropsWithChildren<RulesComponentProps>
) => {
  const isrContext = useISRContext();
  // useEffect(() => {
  const [rules, setRules] = useState<RuleObjectStateType[]>([]);
  const [inputRef, setInputRef] = useState<any>();
  const [showRulesMenu, setShowRulesMenu] = useState<boolean>(false);
  const [editId, setEditId] = useState<any>(null);
  const [ruleType_, setRuleType_] = useState<string | null | undefined>(null);
  let {
    selectedItem,
    userProjectDataModels,
    setUserProjectDataModels,
    indexInfo,
    createISRProject
  } = props;

  
  

  useEffect(() => {
    let prevRules;
    if (
      selectedItem &&
      "belongsToDataModel" in selectedItem &&
      selectedItem?.belongsToDataModel
    ) {
      prevRules =
        userProjectDataModels?.project.dataModels[
          indexInfo?.dataModelIndex ?? -1
        ]?.data.fields[indexInfo?.fieldIndex ?? -1]?.rules ?? [];
    } else {
      prevRules =
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data?.rules ?? [];
    }
    if (Array.isArray(prevRules)) {
      setRules(prevRules);
      setEditId(prevRules[prevRules.length - 1]?.id)
    }
  }, [selectedItem, userProjectDataModels]);

  // useEffect(() => {
  //   scrollToBottom();
  // });

  // const scrollToBottom = () => {
    //if (inputRef) inputRef.scrollIntoView({ behavior: "smooth" });
  // };

  const updateRules = (localRules: RuleObjectStateType[]) => {
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      const newRules: RuleObjectType[] = localRules.map((x) => {
        return {
          id: x.id,
          ruleExp: x.ruleExp,
          ruleScope: x.ruleScope ?? {},
          name: x.name,
          description: x.description ?? "",
          type: x.type,
        };
      });
      if (
        selectedItem &&
        "belongsToDataModel" in selectedItem &&
        selectedItem?.belongsToDataModel
      ) {
        const dataModelToUpdate =
          newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
        if (
          dataModelToUpdate &&
          dataModelToUpdate.data &&
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]
        ) {
          dataModelToUpdate.data.fields[
            indexInfo?.fieldIndex ?? -1
          ].rules = newRules;
        }
      } else {
        const fieldToUpdate =
          newDataModels.project.fields[
            indexInfo?.fieldOutsideDataModelIndex ?? -1
          ];
        if (fieldToUpdate && fieldToUpdate.data) {
          fieldToUpdate.data.rules = newRules;
        }
      }
      return newDataModels;
    });
    createISRProject(true)
  };


  const handleClick = (id: any, type: string, ruleType:string|null|undefined) => {
    if (type === "edit") {
      setEditId(id);
      setRuleType_(ruleType);
      setShowRulesMenu((prev) => !prev);
    } else {
    let localRules = [...rules];
    localRules = rules.filter((x) => x.id !== id);
    setRules(localRules);
    updateRules(localRules)
    }
  };

  return (
    <SB3RuleContextProvider>

    <div id={props.id} className="cart-style-dm tw-bg-white" ref={(ele) => setInputRef(ele)}>
      <div className="tw-flex tw-justify-between tw-items-center ">
        <label className="cart-title">{RELATIONSHIPS}</label>
        <CreateRuleMenu
          handleOptionClick ={
            (type: string) => {
            setRuleType_(type);
            setShowRulesMenu((prev) => !prev);
              setEditId(null);
          }}
            mergeStates={() => { setUserProjectDataModels(isrContext?.networkUserProjectDataModels); }}
        />
      </div>
      {rules &&
        rules.map((rule,ruleIndex ) => (
          <div key={ruleIndex}>
            <RulesCard
            id={rule.id}
            ruleName={rule.name}
            description={rule.description}
            ruleType={rule.type}
            ruleExp={rule.ruleExp}
            onClickHandler={(id: any, type: string) => {
              handleClick(id, type, rule.type);
            }}
          />
          
          </div>

        ))}
      {showRulesMenu && (
          <ManageRulesDialog
            showRulesMenu={showRulesMenu}
            setShowRulesMenu={setShowRulesMenu}
            selectedItem={selectedItem}
            userProjectDataModels={userProjectDataModels}
            setUserProjectDataModels={setUserProjectDataModels}
            indexInfo={indexInfo}
            editId={editId}
            ruleType={ruleType_}
            createISRProject={createISRProject}
            featureType={props?.featureType}
          />

      )}
    </div>
    </SB3RuleContextProvider>

  );
};

export default RulesComponent;
